export const GoingBackService = (() => {
  let referrerUrl: string | null = null;  // Stores the external site
  let firstInternalPage: string | null = null; // First internal page visited
  const locationHistory = new Map<string, { time: number; search: string; path: string }>();

  // Helper to track navigation events
  const trackHistory = () => {
    const path = window.location.pathname;
    const search = window.location.search;
    const time = Date.now();

    // If this is the first page visited internally, store it
    if (!firstInternalPage) {
      firstInternalPage = path;
    }

    locationHistory.set(path, { time, search, path });
  };

  // Setup event listeners
  const setupListeners = () => {
    // Track history when the browser back/forward button is used
    window.addEventListener("popstate", () => {
      trackHistory();
    });

    // Override pushState and replaceState to track SPA navigation
    const originalPushState = history.pushState;
    history.pushState = function (...args) {
      originalPushState.apply(this, args);
      trackHistory();
    };

    const originalReplaceState = history.replaceState;
    history.replaceState = function (...args) {
      originalReplaceState.apply(this, args);
      trackHistory();
    };
  };

  // Store the external referrer (only runs once)
  const registerReferrer = () => {
    const referrer = document.referrer;
    if (referrer) {
      try {
        const url = new URL(referrer);
        referrerUrl = referrer; // Store the full referrer URL
      } catch (error) {
        console.error("Invalid referrer URL:", error);
      }
    }
  };

  // Handle back navigation
  const handleBack = () => {
    const path = window.location.pathname;

    if (firstInternalPage && path === firstInternalPage && referrerUrl) {
      // If we're on the first internal page, redirect to the external site
      locationHistory.clear();
      window.location.href = referrerUrl;
    } else {
      window.history.back();
    }
  };

  (function initialize() {
    registerReferrer();
    trackHistory();
    setupListeners();
  })();

  return {
    handleBack,
    registerReferrer,
  };
})();
